module.exports = "https://static.wanderu.com/static/media/carriers.5482f4f1.png";